import http from 'lib/utils/axios';

const WIDGET_URL = '/widget/';

export const fetchByType = (page, type) => http.get(`${WIDGET_URL}page/${page}/?type=${type}`);
export const fetchByCode = (code) => http.get(`${WIDGET_URL}${code}`);
export const create = payload => http.post(`${WIDGET_URL}`, payload);
export const update = payload => http.put(`${WIDGET_URL}${payload.code}`, payload);
export const remove = payload => http.delete(`${WIDGET_URL}delete/${payload.code}`);

export default {
  fetchByType,
  fetchByCode,
  create,
  update,
  remove,
};
